export default "__VITE_ASSET__be0266ab__"